import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './al-w4.component.html';
import { SignaturePadModal } from '../signature/signature-pad.component';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const AlW4Component = {
    templateUrl,
    controller: Alw4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function Alw4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $q, $uibModal, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.alW4Form;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.onSign = onSign;
    vm.onEditClicked = onEditClicked;
    //ssn variables
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.onClose = onClose;
    vm.ssnBlur = ssnBlur;
    vm.onSave = onSave;
    //ownerview: review
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.showSavedNotification = false;
    vm.editable = true;
    vm.savedData = false;
    vm.previewUrl;
    vm.disableEmpFields = true;
    vm.state = {
        view: 'W4'
    };

    vm.$onInit = function () {
        console.log(vm.resolve);
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'DD/MM/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;

            });

        if (vm.savedInputs != null && vm.savedInputs.EmployeeFirstNameMiddleInitialLastName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.EmployeeFirstNameMiddleInitialLastName != null) {
            //if (vm.application) {
            //    vm.editable = !(vm.application && vm.application.ProvinceW4DocumentId !== null && vm.application.ProvinceW4 !== 'Review' && vm.application.ProvinceW4 !== 'Preview');
            //}
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            //prefill this.userInputs
            console.log(vm.userInputs);
            fillEmployee(vm.userInputs);
        } else {
            //prefill user info
            //vm.alW4Form.$setDirty();
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView) {
            if (this.userInputs != null && this.userInputs.Employername != null) {
                vm.employerName = this.userInputs.Employername;
                vm.employerFederalEIN = this.userInputs.EmployerfederalEIN;
                vm.employerAddress = this.userInputs.EmployerstreetAddress1streetAddress2;
                vm.employerCity = this.userInputs.Employercity;
                vm.employerState = vm.stateProvinces.find(x => x.StateName === this.userInputs.Employerstate);
                vm.employerZipCode = this.userInputs.Employerzip;
            } else if (vm.ownerInfo) {
                vm.employerName = vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName;
                vm.employerFederalEIN = vm.ownerInfo.FEIN;
                vm.employerAddress = [vm.ownerInfo.ShippingAddress.StreetLine1, vm.ownerInfo.ShippingAddress.StreetLine2, vm.ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', ');
                vm.employerCity = vm.ownerInfo.ShippingAddress.City;
                vm.employerState = vm.stateProvinces.find(x => x.StateName === vm.ownerInfo.ShippingAddress.StateName);
                vm.employerZipCode = vm.ownerInfo.ShippingAddress.PostalCode;
            }
        }
        vm.editable = resolveEditable();
        utilityService.hideLoading();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }

    ////event to track if user changed any form data
    //$scope.$watch(() => angular.toJson(vm.alW4Form), function (newVal, oldVal) {
    //    if (newVal !== oldVal) {
    //        vm.ISPreview = false;
    //    }
    //}, true);

    $scope.$watch('vm.alW4Form.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    // Kendo drop-downs hold the selected state object; mirror the id into the hidden inputs that carry form validation (user-profile pattern).
    $scope.$watch(function () {
        return vm.employeeState;
    }, function (v) {
        vm.employeeStateID = v ? v.StateProvinceID : null;
    });
    $scope.$watch(function () {
        return vm.employerState;
    }, function (v) {
        vm.employerStateID = v ? v.StateProvinceID : null;
    });

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending') {
            vm.employeeName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }


    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        //warning for pending changes
        if (!vm.prefilled) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "onboarding-document.federalW4";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }


    function fillEmployee(data) {
        vm.employeeName = data.EmployeeFirstNameMiddleInitialLastName;
        vm.employeeSsn = data.EmployeeSocialSecurityNumber;
        vm.address = data.EmployeeStreetAddress1StreetAddress2;
        vm.date = moment(data.Date, 'DD/MM/YYYY').toDate();
        vm.city = data.EmployeeCity;
        vm.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
        vm.zipCode = data.EmployeeZip;
        vm.exemptionCheckbox = data.FilingStatusLine1 === '0';
        if (data.FilingStatusLine2 !== '') {
            vm.filingStatus = data.FilingStatusLine2;
        }
        if (data.FilingStatusLine3 !== '') {
            vm.filingStatus = data.FilingStatusLine3;
        }
        vm.dependents = data.Dependents !== 0 ? Number(data.Dependents) : ''
        vm.addlAmount = data.AdditionalStateWithholding !== 0 ? Number(data.AdditionalStateWithholding) : '';
        vm.totalExemptions = data.TotalExemptions !== 0 ? Number(data.TotalExemptions) : '';

        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;
        }
        vm.prefilled = true;
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '65', pages)
            .then(function (result) {
                utilityService.hideLoading();
                return result;
            }).then(function () {
                utilityService.hideLoading();
            });

    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.alW4Form && vm.alW4Form.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onPreview() {
        if (vm.alW4Form && vm.alW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.employeeState.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatusLine1: vm.exemptionCheckbox ? 0 : '',
            FilingStatusLine2: (vm.filingStatus === 'S' || vm.filingStatus === 'MS') ? vm.filingStatus : '',
            FilingStatusLine3: (vm.filingStatus === 'H' || vm.filingStatus === 'M') ? vm.filingStatus : '',
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.addlAmount,
            TotalExemptions: vm.totalExemptions,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            Signature: vm.signimage
        };
        if (vm.ownerView) {
            let ownerData = {
                Employername: vm.employerName,
                EmployerfederalEIN: vm.employerFederalEIN,
                EmployerstreetAddress1streetAddress2: vm.employerAddress,
                Employercity: vm.employerCity,
                Employerstate: vm.employerState.Abbr,
                Employerzip: vm.employerZipCode
            }
            formData = { ...formData, ...ownerData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 65)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "AL W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '2');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        showSignaturePopup: () => {
                            return vm.showSignaturePopup;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true; //employer version
                    return onSubmit();
                }
            }).catch((err) => {
                utilityService.hideLoading();
                console.log(err)
            });
        //return onboardingDocumentService.preview(vm.employee.UserName, formData, 65)
        //    .then(function (result) {
        //        utilityService.hideLoading();
        //        vm.ISPreview = true;
        //        return result;
        //    }).catch((err) => {
        //        utilityService.hideLoading();
        //        console.log(err)
        //    });
    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.employeeState.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatusLine1: vm.exemptionCheckbox ? 0 : '',
            FilingStatusLine2: (vm.filingStatus === 'S' || vm.filingStatus === 'MS') ? vm.filingStatus : '',
            FilingStatusLine3: (vm.filingStatus === 'H' || vm.filingStatus === 'M') ? vm.filingStatus : '',
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.addlAmount,
            TotalExemptions: vm.totalExemptions,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
        };

        return onboardingDocumentService.save(vm.employee.UserName, formData, '65').then(function () {
            vm.isSaved = true;
            vm.alW4Form.$setPristine();
            vm.showSavedNotification = true;
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }


    function onSubmit() {

        if (vm.alW4Form && vm.alW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        //utilityService.showLoading()
        let updatePromises = [];
        let submitApplicationPromise = $q.resolve();
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.alW4Form && vm.alW4Form.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {

            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
                return;
            }

            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }

            let formData = {
                RequestTypeId: '2',
                EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
                EmployeeSocialSecurityNumber: vm.employeeSsn,
                EmployeeStreetAddress1StreetAddress2: vm.address,
                EmployeeCity: vm.city,
                EmployeeState: vm.employeeState.Abbr,
                EmployeeZip: vm.zipCode,
                FilingStatusLine1: vm.exemptionCheckbox ? 0 : '',
                FilingStatusLine2: (vm.filingStatus === 'S' || vm.filingStatus === 'MS') ? vm.filingStatus : '',
                FilingStatusLine3: (vm.filingStatus === 'H' || vm.filingStatus === 'M') ? vm.filingStatus : '',
                Dependents: vm.dependents,
                AdditionalStateWithholding: vm.addlAmount,
                TotalExemptions: vm.totalExemptions,
                Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
                Signature: vm.signimage,
                IsI9EmployeeMode: !vm.ownerView
            };

            if (vm.ownerView) {
                let ownerData = {
                    Employername: vm.employerName,
                    EmployerfederalEIN: vm.employerFederalEIN,
                    EmployerstreetAddress1streetAddress2: vm.employerAddress,
                    Employercity: vm.employerCity,
                    Employerstate: vm.employerState.Abbr,
                    Employerzip: vm.employerZipCode
                }
                formData = { ...formData, ...ownerData }
            }

            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, '65');
            updatePromises.push(submitApplicationPromise);
        }

        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function onPreviewInPage() {
        if (vm.alW4Form && vm.alW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            EmployeeFirstNameMiddleInitialLastName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.employeeState.Abbr,
            EmployeeZip: vm.zipCode,
            FilingStatusLine1: vm.exemptionCheckbox ? 0 : '',
            FilingStatusLine2: (vm.filingStatus === 'S' || vm.filingStatus === 'MS') ? vm.filingStatus : '',
            FilingStatusLine3: (vm.filingStatus === 'H' || vm.filingStatus === 'M') ? vm.filingStatus : '',
            Dependents: vm.dependents,
            AdditionalStateWithholding: vm.addlAmount,
            TotalExemptions: vm.totalExemptions,
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            IsI9EmployeeMode: !vm.ownerView
        };

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 65)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                utilityService.hideLoading();
                console.log(err)
            });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const ALW4Modal = {
    component: "apexALW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

